import { NgModule } from '@angular/core';
import { DefinitionsService } from './definitions.service';

@NgModule({
    imports: [
    ],
    declarations: [
    ],
    exports: [
    ],
    providers: [
        DefinitionsService
    ]
})

export class DefinitionsModule {}
